import React, {useEffect} from 'react';
import {Provider, useDispatch} from 'react-redux';
import {fetchFeatureToggles} from './src/redux/featureToggles/thunks';
import {fetchPpcConfig} from './src/redux/ppcConfig/thunks';
import store from './src/redux/store';

const ApplicationInit: React.FC<any> = props => {
  const dispatch = useDispatch();

  useEffect(() => {
    const initialFetch = async () => {
      dispatch(fetchFeatureToggles());
      dispatch(fetchPpcConfig());
    };

    initialFetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // run once

  return props.children;
};

export default ({element}) => {
  return (
    <Provider store={store}>
      <ApplicationInit>{element}</ApplicationInit>
    </Provider>
  );
};
